import "./styles.scss";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { SideMenu } from "../../components/SideMenu";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { CAMPAINS_GET } from "../../API/campainApi";

export function Home() {
  const [campain, setCampain] = useState(null);
  const [loading, setLoading] = useState(false);

  const { user } = useContext(UserContext);
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    async function getCampains() {
      setLoading(true);

      const { url, options } = CAMPAINS_GET(token);

      const campainResponse = await fetch(url, options);
      const campainJson = await campainResponse.json();

      setCampain(campainJson.data.data);

      setLoading(false);
    }

    getCampains();
  }, [token]);

  return (
    <div className="homeContainer fadeIn">
      <div>
        <SideMenu />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="header">
              <h1>Bem vindo(a), {user !== null && user.name}.</h1>
            </div>
            <span className="subtitle">
              Para começar, escolha qual campanha quer vizualizar.
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="campainList">
              {loading || campain === null ? (
                "Carregando..."
              ) : campain.length <= 0 ? (
                <p className="text-danger">
                  Você não está cadastrado em nenhuma campanha.
                </p>
              ) : (
                <table className="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nome</th>
                      <th>Ação</th>
                    </tr>
                  </thead>

                  <tbody>
                    {campain.map((item, index) => {
                      return (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td>
                            <Link to={`/campain/${item.id}`}>
                              <button className="acess">Acessar</button>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
